{
  "remove": "제거"
}
